const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/

export function toLocalDateTime(value) {
  return DATE_ONLY.test(value) ? `${value}T00:00:00` : value
}

export function toDateTimeAttribute(value) {
  return DATE_ONLY.test(value) ? value : new Date(value).toISOString()
}

const DAY = 86400000

const parisDay = value => {
  const parts = new Intl.DateTimeFormat('en-US', {
    timeZone: 'Europe/Paris',
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
  }).formatToParts(new Date(value))
  const part = type => Number(parts.find(p => p.type === type).value)
  return Date.UTC(part('year'), part('month') - 1, part('day'))
}

export function parisDayOffset(value, now = new Date()) {
  return (parisDay(value) - parisDay(now)) / DAY
}

export function isTomorrowInParis(value, now = new Date()) {
  if (!value) return false
  return parisDayOffset(value, now) === 1
}
